import React, { useEffect, useRef } from "react";

// Generic TradingView embeddable widget loader (free, no API key).
export default function TradingViewWidget({ type, config, height = 400 }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    ref.current.innerHTML = "";
    const container = document.createElement("div");
    container.className = "tradingview-widget-container__widget";
    container.style.height = typeof height === "number" ? `${height}px` : height;
    ref.current.appendChild(container);
    const script = document.createElement("script");
    script.src = `https://s3.tradingview.com/external-embedding/embed-widget-${type}.js`;
    script.async = true;
    script.innerHTML = JSON.stringify({ colorTheme: "dark", isTransparent: true, locale: "en", ...config });
    ref.current.appendChild(script);
    return () => { if (ref.current) ref.current.innerHTML = ""; };
  }, [type, JSON.stringify(config), height]);
  return <div className="tradingview-widget-container" ref={ref} style={{ height }} />;
}
